import App from './AppActions';
import Trends from './TrendsActions';
import { getApiConfig } from '../config/apiConfig';

export default class Actions {
    constructor(rootStore) {
        const apiServer = rootStore._clientConfig.API_SERVER;
        const apiKey = rootStore._clientConfig.API_KEY;

        const apiConfig = getApiConfig(apiServer, apiKey);
        this._api = apiConfig.instance;
        this._rootStore = rootStore;

        this.app = new App(this._rootStore, this._api);
        this.trends = new Trends(this._rootStore, this._api);
    }
}



// WEBPACK FOOTER //
// ./src/common/actions/index.js